import React from 'react';
import PropTypes from 'prop-types';

const ServiceTitle = ({ children, className }) => <p className={`station ${className}`}>{children}</p>

ServiceTitle.propTypes = {
  className: PropTypes.string
}

ServiceTitle.defaultProps = {
  className: ''
}

export default ServiceTitle;


// WEBPACK FOOTER //
// ./src/components/ServiceTitle.js